const doc = [({"da":({"js":({"admin":({"bundle_photo_product":({"create_card":({"create_bundle_photo_product":"Opret fotoprodukt i bundle"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;